import './library/polyfills'
import { setupTealium } from './library/tealium'
import { trackableElementAttrName as _trackableElementAttrName } from './library/clickListener'

export const trackableElementAttrName = _trackableElementAttrName()

export {
  recordPageView,
  recordClick,
  recordCustomEvent,
  recordCustomError,
  setPageId,
  refreshTrackingIds
} from './library/actions'

export {
  basePageObject,
  baseKalturaConfig,
  KalturaEvents,
} from './library/config'

export default setupTealium
